import { render, staticRenderFns } from "./RegisterDetail.vue?vue&type=template&id=af5c6aaa&"
import script from "./RegisterDetail.vue?vue&type=script&lang=js&"
export * from "./RegisterDetail.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDetail.vue?vue&type=style&index=0&id=af5c6aaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports